import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";
import { LoaderService } from "src/app/_metronic/partials/content/loader/loader.service";
import { Attachment } from "src/app/_metronic/core/classes/core.class"

@Injectable()
export class DocumentsService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageUserDocument(data) {
        return this.httpClient.post(`${this.apiUrl}/manageUserDocument`, data).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getUserDocumentById(id) {
        return this.httpClient.get(`${this.apiUrl}/getUserDocumentById/` + id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public getAllUserDocument(state): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllUserDocument/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    manageUserDocumentType(data) {
        return this.httpClient.post(`${this.apiUrl}/manageUserDocumentType`, data).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getUserDocumentTypeById(id) {
        return this.httpClient.get(`${this.apiUrl}/getUserDocumentTypeById/` + id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public getAllUserDocumentType(state): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllUserDocumentType/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    public getAllUserDocumentTypeName() {
        return this.httpClient.get(`${this.apiUrl}/getAllUserDocumentTypeName/`).pipe(
            map((response: any) => {
                return response.data
            })
        )
    }
    getUserByBranchId() {
        return this.httpClient.post(`${this.apiUrl}/getAllUserByBranch/`,{}).pipe(
          map((response: any) => {
            return {
              data: response.data,
            } as GridDataResult
          })
        ) as any as Observable<GridDataResult>
      }
      deleteAttachments(attachments: Attachment) {
        return this.httpClient.post(`${this.apiUrl}/fileBulkDelete`, attachments).pipe(
          map((response: any) => {
            return response;
          })
        );
      }
    addAttachments(attachments: Attachment[]) {
        return new Promise((resolve, reject) => {
          this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).pipe(
            map(res => res))
            .subscribe(res => {
              resolve(res);
            }, (err) => {
              reject(err);
            });
        });
      }
}
